import { makeFetchSlice, fetchEdgeDataThunk } from 'app/redux-fetch'

import { AppDispatch } from 'app/store'
import {
  DELETE_USER_REDUCER_NAME,
  DOMAIN_USERS_LIST_REDUCER_NAME,
  UPDATE_USER_PERMISSIONS_REDUCER_NAME,
} from 'features/team/consts'
import { fetchDomains } from 'features/domains/api'
import {
  checkEmail,
  checkEmailParams,
  deleteUserFromDomain,
  postUserToDomain,
  PostUserToDomainPayload,
  updateUserPermissions,
  UpdateUserPermissionsPayload,
} from 'features/team/api'

const domainUsersListSlice = makeFetchSlice(DOMAIN_USERS_LIST_REDUCER_NAME)
export const domainUsersListReducer = domainUsersListSlice.reducer
export const domainUsersListActions = domainUsersListSlice.actions

export const fetchDomainUsersListThunk = (domainId: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      await fetchEdgeDataThunk({
        dispatch,
        actions: domainUsersListActions,
        asyncFunc: () =>
          fetchDomains({ domainid: domainId, users: 'direct', depth: 0 }),
      })
    } catch (error) {
      console.log('Error fetching domain users', error)
    }
  }
}

const deleteUserFromDomainSlice = makeFetchSlice(DELETE_USER_REDUCER_NAME)
export const deleteUserFromDomainReducer = deleteUserFromDomainSlice.reducer
export const deleteUserFromDomainActions = deleteUserFromDomainSlice.actions

export const deleteUserFromDomainThunk = (userId: string, domainId: string) => {
  return async (dispatch: AppDispatch) => {
    await fetchEdgeDataThunk({
      dispatch,
      actions: deleteUserFromDomainActions,
      asyncFunc: () => deleteUserFromDomain(userId, domainId),
    })
  }
}

const updateUserPermissionsSlice = makeFetchSlice(
  UPDATE_USER_PERMISSIONS_REDUCER_NAME
)
export const updateUserPermissionsReducer = updateUserPermissionsSlice.reducer
export const updateUserPermissionsActions = updateUserPermissionsSlice.actions

export const updateUserPermissionsThunk = (
  userId: string,
  domainId: string,
  params: UpdateUserPermissionsPayload
) => {
  return async (dispatch: AppDispatch) => {
    await fetchEdgeDataThunk({
      dispatch,
      actions: updateUserPermissionsActions,
      asyncFunc: () => updateUserPermissions(userId, domainId, params),
    })
  }
}

export const checkEmailThunk = (params: checkEmailParams) => {
  return async (dispatch: AppDispatch) => {
    return await fetchEdgeDataThunk({
      dispatch,
      asyncFunc: () => checkEmail(params),
    })
  }
}

export const postUserToDomainThunk = (
  domainId: string,
  payload: PostUserToDomainPayload
) => {
  return async (dispatch: AppDispatch) => {
    return await fetchEdgeDataThunk({
      dispatch,
      asyncFunc: () => postUserToDomain(domainId, payload),
    })
  }
}
